import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

const updateRedemptionStatus = async function(redemptionId, uid, status, updatedBy, courierName = null, trackingNumber = null) {
    const db = firebase.firestore();
    const redemptionRef = db.collection('wellness_rewards/' + redemptionId + '/redeem_history').doc(uid);
    
    const updateData = {
        status: status,
        updatedDate: new Date(),
        updatedBy: updatedBy
    };
    
    // Add tracking information if provided
    if (courierName && trackingNumber) {
        updateData.courierName = courierName;
        updateData.trackingNumber = trackingNumber;
    }
    
    await redemptionRef.update(updateData);
    
    return true;
};

export default updateRedemptionStatus; 